<template>
  <div class="h-full card show">
    <div class="h-full border-1">
      <div class="relative h-full">
        <div class="absolute z-50 h-15 right-0 top-0 hidden btn">
          <el-button
            type="primary"
            size="default"
            class="h-10 w-8 rounded-t-none rounded-br-none"
            @click="$emit('del', item.objid)"
          >
            <span class="iconfont icon-shanchu relative right-6px"></span>
          </el-button>
        </div>

        <router-link :to="{ name: 'ProductDetail', params: { id: item.objid } }">
          <img
            :src="$firstImage(item.images, 'small')"
            alt
            :onerror="defaultUrl"
            class="img rounded-t w-full h-52"
          />

          <div class="h-full px-4 pt-3 pb-2 text-left">
            <p class="font-bold text-base">{{ item.title }}</p>

            <div>
              <p class="text-sm mt-1 text-gray-400 space-x-2 truncate">
                <span>{{ item.obj.attribute_text }}</span>
              </p>
              <p class="mt-2">
                <span class="text-red-600">{{ $p(item.obj.price) }}</span>
              </p>
            </div>
          </div>
        </router-link>

        <div class="absolute bottom-0 z-50 h-15 w-full hidden btn">
          <el-button
            type="primary"
            size="default"
            class="h-full w-full rounded-t-none"
            @click="$emit('add', item.objid)"
          >{{ $t("加入购物车") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  props: { item: Object },
  setup() {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const show = ref(false);
    return { show, defaultUrl };
  },
});
</script>

<style scoped lang="scss">@import "@/style/stl.scss";
.show:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(21, 186, 99, var(--tw-ring-opacity));
}
.show:hover .btn {
  display: block;
}
.airlift::before {
  content: "空运：$ ";
}
.tally::after {
  content: "枝/扎";
}</style>
